import { render } from "./clientstatus.vue?vue&type=template&id=5a70d9aa"
import script from "./clientstatus.vue?vue&type=script&lang=js"
export * from "./clientstatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__